export const educatorTestimonials = [
  {
    quote:
      "PlayMath.org is my favorite low-prep math activity. Students have fun while practicing math.",
    source: "- Brooke Gilliano, K-5 Teacher",
  },
  {
    quote:
      "The games are fun and engaging while also promoting mathematical thinking and problem-solving.",
    source: "- Holly Alexander, K-5 Teacher",
  },
  {
    quote:
      "The games make my students think and problem-solve instead of just clicking through practice problems.",
    source: "- Holly Alexander, K-5 Teacher",
  },
  {
    quote:
      "I've tried countless websites and games. That's when I came across PlayMath.org. No ads, no distractions, no complaints.",
    source: "- Sam, K-5 Teacher",
  },
  {
    quote:
      "My students think they're playing a game, but they're actually building their math skills.",
    source: "- Garcia Math Party, K-5 Teacher",
  },
  {
    quote: "This is the kind of website I wish I had known about sooner.",
    source: "- Kayla, The Lit Teacher, K-5 Teacher",
  },
  {
    quote: "PlayMath.org kept my students focused and engaged while I worked with small groups.",
    source: "- Mr. Gusman, K-5 Teacher",
  },
  {
    quote:
      "PlayMath.org became my favorite digital station because it allows students to work on math skills while playing games and having fun.",
    source: "- Mr. Gusman, K-5 Teacher",
  },
  {
    quote:
      "Tests measure answers, not thinking. But puzzles and logic games reveal the gears turning in their minds.",
    source: "- 4th Grade Teacher",
  },
] as const;
